import React, { useState } from "react";
import { useSelector } from "react-redux";
import PlusIcon from '../../../assets/images/comparePrice/plus-icon.svg';
import MinusIcon from '../../../assets/images/comparePrice/minus-icon.svg';
import CurrencyFormat from "react-currency-format";
import { sleep } from "../../../redux/reducers/utils";
import { PriceDisplay } from "../Summary/Summary";

const SummaryTotal = ({ item, mode, itemIndex, onChangeFn, showPickThis = false, surchargeObj }) => {
  const [showDetail, setShowDetail] = useState(false);
  const state = useSelector((state) => state.reducer);
  let CompareFirstMfg =
    state.const_var.ComparisionDataArray[state.params.m_s_n_1]
      ? state.const_var.ComparisionDataArray[state.params.m_s_n_1].post_data?.building
      : "";
  let CompareSecondMfg =
    state.const_var.ComparisionDataArray[state.params.m_s_n_2] != undefined
      ? state.const_var.ComparisionDataArray[state.params.m_s_n_2].post_data?.building
      : "";

  let viewSummaryData =
    item != undefined && item.compareManufactureIndex == "_1"
      ? CompareFirstMfg
      : CompareSecondMfg;

  let buidingPriceArr =
    viewSummaryData != undefined && viewSummaryData.BuildingPriceArrarNew;
  if (item?.compareManufactureIndex == "0") {
    buidingPriceArr = state.const_var.BuildingPriceArrar;
  }
  let dealerDepositPercentage = viewSummaryData != undefined && viewSummaryData.down_payment_rate
  if (item?.compareManufactureIndex == "0") {
    dealerDepositPercentage = state.const_var.post_data.building.down_payment_rate;
  }

  const holdClick = async (itemIndex) => {
    await sleep(2000)
    onChangeFn(itemIndex)
  }
  return (
    <div
      className="deposit-dropdown-wrapper"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="prices-total-deposit">
        {item !== undefined && (
          <div className="summary-total-container">
            <div className="summary-total-title">Price Summary</div>
            <div>
              {
                showPickThis && itemIndex !== 0 &&
                <button
                  className="btn btn-primary pick-building"
                  onClick={() => {
                    holdClick(itemIndex)
                  }}
                >
                  PICK THIS BUILDING
                </button>
              }
              {
                state.isShowComparePriceModal && mode !== 'popup' &&
                <div className="summary-total-collapse" onClick={() => { if (state.isShowComparePriceModal) setShowDetail(!showDetail) }} >
                  {
                    !showDetail ?
                      <img src={process.env.REACT_APP_BASE_URL + PlusIcon} alt="collapse icon" /> :
                      <img src={process.env.REACT_APP_BASE_URL + MinusIcon} alt="collapse icon" />
                  }
                </div>
              }
            </div>
          </div>
        )}
        {
          (mode === 'popup' || !state.isShowComparePriceModal || (state.isShowComparePriceModal && showDetail)) &&
          <ul>
            <li>
              {
                item?.compareManufactureIndex == '_2' ?
                  <aside className="deposit-price-label">Building Amount {surchargeObj && surchargeObj['surFlag2'] == false ? surchargeObj['surValue2'] : ""}</aside>
                  :
                  item?.compareManufactureIndex == "_1" ?
                    <aside className="deposit-price-label">Building Amount  {surchargeObj && surchargeObj['surFlag1'] == false ? surchargeObj['surValue1'] : ""}</aside>
                    :
                    <aside className="deposit-price-label">Building Amount {surchargeObj && surchargeObj['surFlag'] == false ? surchargeObj['surValue'] : ""}</aside>
              }
              <aside className="deposit-price-value">
                <PriceDisplay value={Number(buidingPriceArr?.["order_total"] || 0).toFixed(2)} />
                { }
              </aside>
            </li>

            <li>
              <aside className="deposit-price-label">
                {state.const_var.crmSetting.is_hide_discount != false && state.const_var.manufacturer_discount_label && item?.compareManufactureIndex == "0" ?
                  state.const_var.manufacturer_discount_label : "Manufacturer Discount"}
              </aside>
              <aside className="deposit-price-value">
                <PriceDisplay value={Number(buidingPriceArr?.["discount_order_total"] || 0).toFixed(2)} />
              </aside>
            </li>

            <li className="highlight-deposit">
              {
                item?.compareManufactureIndex == '_2' ?
                  <aside className="deposit-price-label">Sub Total {surchargeObj && surchargeObj['surFlag2'] == true ? surchargeObj['surValue2'] : ""}</aside>
                  :
                  item?.compareManufactureIndex == "_1" ?
                    <aside className="deposit-price-label">Sub Total {surchargeObj && surchargeObj['surFlag1'] == true ? surchargeObj['surValue1'] : ""}</aside>
                    :
                    <aside className="deposit-price-label">Sub Total {surchargeObj && surchargeObj['surFlag'] == true ? surchargeObj['surValue'] : ""}</aside>
              }
              <aside className="deposit-price-value sub-total-value">
                <PriceDisplay value={Number(buidingPriceArr["sub_order_total"] || 0).toFixed(2)} />
              </aside>
            </li>

            <li
              className={
                buidingPriceArr?.["has_grvy"] == 0 &&
                  buidingPriceArr?.["grvy_value"] != 0
                  ? ""
                  : " d-none"
              }
            >
              <aside className="deposit-price-label">Sub Total With Gravy</aside>
              <aside className="deposit-price-value sub-total-value">
                <PriceDisplay value={(Number(buidingPriceArr?.["sub_order_total"] || 0) + Number(buidingPriceArr?.["grvy_value"] || 0)).toFixed(2)
                } />

              </aside>
            </li>

            <li>
              <aside className="deposit-price-label">Dealer Deposit ({dealerDepositPercentage != undefined ? dealerDepositPercentage + "%" : ''})</aside>
              <aside className="deposit-price-value">
                <PriceDisplay value={Number(buidingPriceArr?.["down_payment_total"] || 0).toFixed(2)} />
              </aside>
            </li>

            <li
              className={
                buidingPriceArr != undefined &&
                  buidingPriceArr["down_payment_discount_total"] != undefined
                  ? ""
                  : "d-none"
              }
            >
              <aside className="deposit-price-label">
                {" "}
                {state.const_var.dealer_discount_label != undefined &&
                  state.const_var.dealer_discount_label != ""
                  ? state.const_var.dealer_discount_label
                  : "Dealer Discount"}
              </aside>
              <aside className="deposit-price-value">
                (<PriceDisplay value={Number(buidingPriceArr?.["down_payment_discount_total"] || 0).toFixed(2)} />)
              </aside>
            </li>

            <li
              className={
                buidingPriceArr != undefined &&
                  buidingPriceArr["processing_fee"] != undefined
                  ? ""
                  : "d-none"
              }
            >
              <aside className="deposit-price-label">Card Processing Fee</aside>
              <aside className="deposit-price-value">
                <PriceDisplay value={Number(buidingPriceArr?.["processing_fee"] || 0).toFixed(2)} />
              </aside>
            </li>

            <li
              className={
                buidingPriceArr != undefined &&
                  (buidingPriceArr["has_grvy"] == 1 ||
                    buidingPriceArr["grvy_value"] == 0)
                  ? "d-none"
                  : ""
              }
            >
              <aside className="deposit-price-label">Gravy</aside>
              <aside className="deposit-price-value">
                <PriceDisplay value={Number(buidingPriceArr?.["grvy_value"] || 0).toFixed(2)} />
              </aside>
            </li>

            <li className="highlight-deposit">
              <aside className="deposit-price-label">Down Payment</aside>
              <aside className="deposit-price-value down-payment-value">
                <PriceDisplay value={(Number(buidingPriceArr?.["new_down_payment_total"] || 0) + Number(buidingPriceArr?.["grvy_value"] || 0)).toFixed(2)} />
              </aside>
            </li>

            <li className={state.const_var.loginSession == true ? "" : ""}>
              <aside className="deposit-price-label">Additional Charges</aside>
              <aside className="deposit-price-value">
                <PriceDisplay value={Number(buidingPriceArr?.["additional_charges"] || 0).toFixed(2)} />
              </aside>
            </li>

            <li className="deposit-price-label">
              <aside className="deposit-price-label">Due Upon Installation</aside>
              <aside className="deposit-price-value">
                <PriceDisplay
                  value={
                    Number(
                      item?.compareManufactureIndex === "0"
                        ? state.const_var.post_data.building?.due_upon_installation
                        : viewSummaryData?.due_upon_installation
                        || 0).toFixed(2)
                  } />
              </aside>
            </li>

            <li className="highlight-deposit">
              <aside className="deposit-price-label">Grand Total</aside>
              <aside className="deposit-price-value">
                <PriceDisplay value={Number(
                  (
                    item?.compareManufactureIndex === "0"
                      ? (state.const_var.post_data.building?.due_upon_installation || 0) +
                      (buidingPriceArr?.["new_down_payment_total"] || 0) +
                      (buidingPriceArr?.["custom_down_payment_total"] || 0) +
                      (buidingPriceArr?.["grvy_value"] || 0)
                      : (viewSummaryData?.due_upon_installation || 0) +
                      (buidingPriceArr?.["new_down_payment_total"] || 0) +
                      (buidingPriceArr?.["grvy_value"] || 0)
                  )
                ).toFixed(2)} />

              </aside>
            </li>
          </ul>
        }
      </div>
    </div>
  );
};

export default SummaryTotal;
